import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid} from 'semantic-ui-react';
import {colors} from '../../../common/constants/colors';
import UsageChart from './chart';

class Charts extends Component {
  renderZonesCharts() {
    const {usageByZone} = this.props;

    return usageByZone.map((item, index) => {
      return (<Card raised fluid key={index}>
        <UsageChart
          data={this.getChartData(item)}
          key={index}
          size='small'
          title={item.zoneName}
          color={colors[index % colors.length]}
        />
      </Card>);
    });
  }

  getChartData({locationsCount, usedLocations, usagePercentage}) {
    return [
      {'label': 'Total ubicaciones', 'value': locationsCount},
      {'label': 'Total ubicaciones con stock', 'value': usedLocations, 'percentage': usagePercentage},
    ];
  }

  render() {
    const {loading, locationsCount, usedLocations, usagePercentage} = this.props;
    const totalData = this.getChartData({locationsCount, usedLocations, usagePercentage});

    if (loading) {
      return null;
    }

    return (
      <div>
        <Card raised fluid>
          <Grid>
            <Grid.Row columns={3}>
              <Grid.Column width={4}></Grid.Column>
              <Grid.Column width={8}>
                <UsageChart data={totalData} size='medium' title='TOTAL' />
              </Grid.Column>
              <Grid.Column width={4}></Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <Card.Group itemsPerRow={3}>
          {this.renderZonesCharts()}
        </Card.Group>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {usageByZone, loading, locationsCount, usedLocations, usagePercentage} = state.warehouseLocationsUsage;
  
  return {loading, locationsCount, usedLocations, usagePercentage, usageByZone};
};

export default connect(mapStateToProps)(Charts);
